// extracted by mini-css-extract-plugin
module.exports = {"bold":"styles_bold__2NNzi","offset":"styles_offset__-cT4h","currentPaymentMethod":"styles_currentPaymentMethod__310HO","header":"styles_header__3Fp2o"};